import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance/axiosInstance";
import { HttpStatusCode } from "axios";
import { MilestoneTaskEstimateChangedAlertResponse } from "./MilestoneTaskEstimateChangedAlertResponse";
import { MilestoneTaskEstimateChangedAlertResponseMapper } from "./MilestoneTaskEstimateChangedAlertResponseMapper";
import { MilestoneTaskEstimateChangedAlert } from "./MilestoneTaskEstimateChangedAlert";

export const loadMilestoneTaskEstimateChangedAlertsAsync = createAsyncThunk(
  "alerts/fetchMilestoneTaskEstimateChangedAlerts",
  async (milestoneTaskId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<
        MilestoneTaskEstimateChangedAlertResponse[]
      >(`/milestoneTaskEstimateChangedAlerts/${milestoneTaskId}`);

      if (response.status !== HttpStatusCode.Ok) {
        throw new Error(
          "Failed to fetch milestone task estimate changed alerts"
        );
      }

      const data = response.data;
      const mapper = new MilestoneTaskEstimateChangedAlertResponseMapper();
      const mappedData: MilestoneTaskEstimateChangedAlert[] = data.map(
        (response) =>
          mapper.mapMilestoneTaskEstimateChangedAlertResponseToMilestoneTaskEstimateChangedAlert(
            response
          )
      );

      return mappedData;
    } catch (error) {
      console.error(
        "Error fetching milestone task estimate changed alerts:",
        error
      );
      return rejectWithValue("An unknown error occurred");
    }
  }
);
